import { StateCreator } from 'zustand';
import { MapInteractionMode } from './types';
import { SelectionSlice } from './selectionSlice';
import { RedlineSlice } from './redlineSlice';

export interface InteractionCallbacks {
  onComplete?: () => void;
  onCancel?: () => void;
}

export interface InteractionSlice {
  interactionMode: MapInteractionMode;
  interactionCallbacks: InteractionCallbacks | null;

  startInteraction: (
    mode: MapInteractionMode,
    callbacks?: InteractionCallbacks,
  ) => void;

  completeInteraction: () => void;

  cancelInteraction: () => void;

  setInteractionMode: (mode: MapInteractionMode) => void;

  resetInteraction: () => void;
}

type CombinedSlice = InteractionSlice & SelectionSlice & RedlineSlice;

export const createInteractionSlice: StateCreator<
  CombinedSlice,
  [],
  [],
  InteractionSlice
> = (set, get) => ({
  interactionMode: 'view',
  interactionCallbacks: null,

  startInteraction: (mode, callbacks) => {
    const prev = get().interactionMode;
    if (prev !== 'view' && mode !== prev) {
      get().resetInteraction();
    }
    set({
      interactionMode: mode,
      interactionCallbacks: callbacks ?? null,
    });
  },

  completeInteraction: () => {
    const cb = get().interactionCallbacks?.onComplete;
    set({
      interactionMode: 'view',
      interactionCallbacks: null,
      activeRedlineTool: 'NONE',
      selected: [],
    });
    cb?.();
  },

  cancelInteraction: () => {
    const cb = get().interactionCallbacks?.onCancel;
    set({
      interactionMode: 'view',
      interactionCallbacks: null,
      activeRedlineTool: 'NONE',
      selected: [],
    });
    cb?.();
  },

  setInteractionMode: (mode) => {
    const prev = get().interactionMode;
    if (prev !== 'view' && mode !== prev) {
      get().resetInteraction();
    }
    set({ interactionMode: mode });
  },

  resetInteraction: () =>
    set({
      interactionMode: 'view',
      interactionCallbacks: null,
      activeRedlineTool: 'NONE',
      selected: [],
    }),
});
